module.exports = __webpack_public_path__ + "media/images/flags/1x1/tha-8fa763f806de3e651e4530677c011a01.svg";